export default "__VITE_ASSET__a90529b2__"